import React, { useEffect, useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { Helmet } from "react-helmet";
import ModalAreaSelector from "../ModalAreaSelector";
import OptinMonster from "../OptinMonster";

export default function Layout(props: any) {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
      console.log("Current URL:", currentUrl);
    }
  }, []);

  //check if the current URL contains "privacy-policy"
  const isPrivacyPolicy = currentUrl.includes("privacy-policy");

  return (
    <>
    <Helmet meta={[ {name:"facebook-domain-verification", content:"yt21y82lomkpm4we7f04urtpprde0c"} ]} />
   

      <OptinMonster/>
      {!isPrivacyPolicy && <ModalAreaSelector />}
      <Header />
      {props.children}
      {!isPrivacyPolicy && <Footer />}
    </>
  )
};
